var _path, _path2, _linearGradient, _path3, _path4, _linearGradient2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendToAccountant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M36.48 47.24l10.673 5.52a3.19 3.19 0 004.285-1.363 3.19 3.19 0 00-1.363-4.285l-16.887-8.734s-4.334-1.251-11.162 2.431"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M51.47 48.556l13.565-7.832a3.19 3.19 0 014.344 1.164 3.19 3.19 0 01-1.164 4.344L51.75 55.738s-8.973 5.488-15.935 1.538-8.435-3.973-9.707-4.162-4.351-.39-4.351-.39"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_568c6d4503c8fda70dc16053420884ef4b9c56aedf65a19906464a1e57edb651",
    gradientUnits: "userSpaceOnUse",
    x1: 14.572,
    y1: 46.833,
    x2: 22.383,
    y2: 46.833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_0_568c6d4503c8fda70dc16053420884ef4b9c56aedf65a19906464a1e57edb651)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.197 39h6.56v15.665h-6.56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M26.752 5.594v26.163h43.051V5.594"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_568c6d4503c8fda70dc16053420884ef4b9c56aedf65a19906464a1e57edb651",
    gradientUnits: "userSpaceOnUse",
    x1: 26.127,
    y1: 13.381,
    x2: 70.428,
    y2: 13.381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_568c6d4503c8fda70dc16053420884ef4b9c56aedf65a19906464a1e57edb651)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M69.803 5.594H26.752l6.573 4.794 6.726 4.903 5.564 4.056 2.499 1.821.251-.179 2.285-1.642 5.663-4.068.371-.265 6.278-4.505 6.841-4.915"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToAccountant);
export default __webpack_public_path__ + "static/media/sendToAccountant.e4da3f0732df55cac5e4477ab1dead28.svg";
export { ForwardRef as ReactComponent };